import { DEVICE_ORDERS } from "../../../constants/constants";
import { useTitle } from "../../../hooks/common/useTitle";
import { ListHandler } from "../../lists/ListHandler";

export const DeviceOrdersPage = () => {
  useTitle("My BNPL Orders");
  return (
    <div className="p15">
      <ListHandler source={DEVICE_ORDERS} />
    </div>
  );
};